import firebase from 'firebase/app';
import 'firebase/messaging';
import i18n from './i18n';
import Store from './store';
import moment from 'moment-timezone';
import Vue from 'vue';
import { router } from '@/routes';
import axios from "axios";

import { getCookie, setCookie } from '@/static';

require('firebase/analytics');

const vue = new Vue({router});
const version = 1; // indexedDB 안의 테이블 구성이 바뀌면 배포전, 버전을 수동으로 업데이트한다. serviceworker 내의 version 도 동일하게 유지해야한다.
const maxNotificationItem = 50; // 최대 저장하는 알림 개수
const firebaseConfig = JSON.parse(process.env.VUE_APP_GOOGLE_DATA);
let messaging;
let sendCnt = 0;
let receivedCnt = 0;
export let isSupported = false;

export function initialize() {
    try {

        // setCookie("intervalTest", "0");
        isSupported = firebase.messaging.isSupported();
        if (isSupported) {
            // Firebase 초기화
            firebase.initializeApp(firebaseConfig);
            // indexDB 초기화
            initIndexDB();
            // 서비스워커 셋팅
            serviceWorkerMessage();
            // intervalTest();
        }
    } catch (e) {
        console.log(`[firebase-config.js] error`, e);
    }
}

// function intervalTest() {
//     setInterval(() => {
//         const intervalStatus = getCookie("intervalTest", "0" );
//         if ( intervalStatus === "0" || intervalStatus === '') {
//             console.log(`[firebase-config] interval stopped... to start test, change cookie named "intervalTest" to 1 or 2`);
//             return;
//         } else if ( intervalStatus === "2" ) {
//             console.log(`[firebase-config] reset interval test!`);
//             sendCnt = 0;
//             receivedCnt = 0;
//             setCookie("intervalTest", "1");
//             return;
//         }
//         const api = 'https://test.api.rebless.pro/';
//         const login = () => {
//             return new Promise ((resolve, reject) => {
//             const data = {
//                 userEmail: 'CLINIC_ACCOUNT_EMAIL',
//                 userPassword: 'CLINIC_ACCOUNT_PW',
//                 fcmToken: 'CLINIC_ACCOUNT_FCM'
//             }
//
//             axios.post(`${api}user/clinicLogin`, data )
//                 .then( resolve )
//                 .catch( reject )
//             })
//         }
//         const reserveSchedule = ( headers ) => {
//             const data = {
//                 seqMedicalRelation : 281, //의사와 환자와 연결된 Key
//                 expectStartDatetime : moment().add(2,'minute').format("YYYY-MM-DDTHH:mm:00Z"),
//                 expectProgressTime : "00:01:00"
//             }
//
//             return axios.post(`${api}schedule/createSchedule`, data, { headers } );
//         }
//         const cancelSchedule = ( headers, seqSchedule ) => {
//             const data = {
//                 seqSchedule
//             }
//             return axios.put(`${api}schedule/cancelNotStartedYetSchedule`, data, { headers } );
//         }
//         login()
//             .then( res => {
//                 if ( res.status !==200 || !res.data.isSuccess ) {
//                     throw new Error(`[firebase-config]intervalTest login failed with failedCode ${ res.data.failedCode }`);
//                 } else {
//                     return {
//                         'x-access-token': res.data.token.accessToken,
//                         'x-refresh-token': res.data.token.refreshToken
//                     };
//                 }
//             })
//             .then( headers => reserveSchedule( headers ) )
//             .then( res2 => {
//                 if ( res2.status !==200 || !res2.data.isSuccess ) {
//                     throw new Error(`[firebase-config]intervalTest reserveSchedule failed with failed code ${ res2.data.failedCode }`);
//                 }
//                 console.log(`[firebase-config]total send count : ${++sendCnt}`);
//                 return res2;
//             })
//             .then( res3 => {
//                 console.log( res3 )
//                 const headers = res3.config.headers;
//                 const seqSchedule = res3.data.insertId;
//                 return cancelSchedule( headers, seqSchedule );
//             })
//             .then( res4 => {
//                 if ( res4.status !==200 || !res4.data.isSuccess ) {
//                     throw new Error(`[firebase-config]intervalTest cancelSchedule failed with failed code ${ res4.data.failedCode }`);
//                 }
//                 console.log(`[firebase-config]total send count : ${++sendCnt}`);
//             })
//             .catch( e => console.error( e ) );
//
//     }, 60000);
// }

function initIndexDB() {
    // IndexedDB 초기화
    let db;
    const openRequest = indexedDB.open('NOTIFICATIONS', version);
    openRequest.onupgradeneeded = function (e) {
        // indexedBD를 처음 만들 경우 onupgradeneeded 가 실행된다. 이 안에서 db 스키마 작성
        // db가 존재하지만, version 이 업그레이드 된 경우도 마찬가지로 이 안에서 업데이트된 db 스키마를 작성한다.
        db = e.target.result;
        if (!db.objectStoreNames.contains('items')) {
            db.createObjectStore('items');
        }
        if (!db.objectStoreNames.contains('lang')) {
            db.createObjectStore('lang');
            const transaction = e.target.transaction;
            transaction.oncomplete = function () {
                setLang(db, localStorage.getItem('lang') || 'en');
            }
        }
        console.log('[Initialize IndexedDB] running onupgradeneeded');
    };
    openRequest.onsuccess = function () {
        console.log('[Initialize IndexedDB] onsuccess!');
    };
    openRequest.onerror = function (e) {
        // 사용자가 웹 응용프로그램에 DB를 만들 수 있는 권한을 주지 않은 경우
        console.log('[Initialize IndexedDB] onerror!', e);
    };
}

function serviceWorkerMessage() {
    messaging = firebase.messaging();
    messaging.usePublicVapidKey(process.env.VUE_APP_PUBLIC_VAPID_KEY);
    // 메세지가 온 경우
    messaging.onMessage(payload => {
        console.log('[firebase-config] Received foreground message ', payload)
        console.log('[firebase-config] receivedCnt : ', ++receivedCnt );
        // DB에 저장하기 위해 payload 커스터마이징
        const data = JSON.parse(payload.data.data);
        // const notification = JSON.parse(payload.data.notification);

        // try {
        //     axios.post(`${process.env.VUE_APP_API_DOMAIN}/log/saveNotiLogForClinic`, {
        //             "osType": 3,
        //             "msgType": data?.msgType,
        //             "seqSchedule": data?.schedule?.seqSchedule,
        //             "msgBody": notification?.body,
        //         }, {
        //             headers: {
        //                 'x-access-token': localStorage.getItem('accessToken') || '',
        //                 'x-refresh-token': localStorage.getItem('refreshToken') || '',
        //             }
        //         })
        // } catch (e) {
        //     console.log('e', e)
        // }

        messageSave(data);
        dataRefresh(data);
    });

    // 백그라운드에서 메세지가 왔을 경우 화면 reload, 읽지 않은 메세지가 있음
    navigator.serviceWorker.addEventListener('message', function (event) {
        if (event.data?.msg === 'reload') {
            Store?.dispatch('refreshScheduleForToday', true);
            Store?.dispatch('changeNotificationsReadStatus', false);
        }
    });
}

function messageSave(data) {
    let db;
    const key = `${data.patient.seqPatient}${data.schedule.seqSchedule}${data.msgType}|${new Date().getFullYear()}${new Date().getMonth()}${new Date().getDay()}${new Date().getHours()}${new Date().getMinutes()}${new Date().getSeconds()}${Math.round(new Date().getMilliseconds() * 0.01)}`;
    const value = {
        key: key,
        data,
        time: new Date().getTime(), // 밀리세컨드 단위를
        read: true
    }

    // indexedDB에 저장
    const openNewRequest = indexedDB.open('NOTIFICATIONS', version);
    openNewRequest.onupgradeneeded = function (event) {
        db = event.target.result;
        if (!db.objectStoreNames.contains('items')) {
            db.createObjectStore('items', {keyPath: value.key});
        }
        console.log('[onMessage] running onupgradeneeded');
    };
    openNewRequest.onsuccess = function (event) {
        db = event.target.result;
        addItemAndUpdateVuex(db, value).then(() => {
            /*This is intentional*/
        });
        console.log('[onMessage] running onsuccess');
    };
    openNewRequest.onerror = function (error) {
        console.log('[onMessage] onerror!', error);
    };
}

function dataRefresh(data) {
    // 알람 커스터마이징하고 얼랏
    i18n.locale = localStorage.getItem('lang') || 'en';
    const msgType = data.msgType;
    const key = `${data.patient.seqPatient}${data.schedule.seqSchedule}${data.msgType}|${new Date().getFullYear()}${new Date().getMonth()}${new Date().getDay()}${new Date().getHours()}${new Date().getMinutes()}${new Date().getSeconds()}${Math.round(new Date().getMilliseconds() * 0.01)}`;
    const title = i18n.t(`notice.push.title.${String(msgType)}`, {
        patientName: data.patient.patientName,
        patientAge: data.patient.patientAge === 0 ? '-' : data.patient.patientAge,
    }).replace('만 -세', '-');
    const scheduleProgressTime = moment( data?.schedule?.scheduleProgressTime, 'kk:mm:ss');
    const scheduleExpectProgressTime = moment( data?.schedule?.scheduleExpectProgressTime, 'kk:mm:ss');
    const options = {
        body: i18n.t(`notice.push.body.${String(msgType)}`,
            {
                scheduleExpectStartDatetime: moment( data.schedule.scheduleExpectStartDatetime).locale(i18n.t('country')).format('llll'),
                scheduleProgressTime: scheduleProgressTime?.hour() * 60 + scheduleProgressTime?.minute(),
                scheduleExpectProgressTime: scheduleExpectProgressTime?.hour() * 60 + scheduleExpectProgressTime?.minute(),
            }),
        icon: '/favicon.png',
        tag: key,
    };

    const notificationMessage = new Notification(title, options);

    // 환자가 예약,취소한 경우이면서, 메인페이지의 경우는 예약 리스트를 리프레쉬 한다. + 환자 목록 페이지
    // 어떠한 알림이라도로 변경
    const pathname = window.location.pathname;
    // const cases = (msgType === 2) || (msgType === 4);
    const mainPage = (pathname === '/') || (pathname === '/appointments') || (pathname === '/patientList');
    // (cases && mainPage) && Store.dispatch('refreshScheduleForToday', true);
    (mainPage) && Store.dispatch('refreshScheduleForToday', true);

    // 알람 클릭 시 현재 창에 포커스
    notificationMessage.onclick = () => {
        (pathname !== '/' || pathname === '/appointments') && vue.$router.push('/');
        window.focus();
    };
}

async function addItemAndUpdateVuex(db, value) {
    if (isSupported) {
        const allItemArr = await GET_ALL_NOTI_ITEMS_FROM_DB();

        if (allItemArr.length >= maxNotificationItem) {
            await REMOVE_NOTI_ITEM_FROM_DB(allItemArr[0].key);
        }
        const transaction = db.transaction(['items'], 'readwrite');
        const store = transaction.objectStore('items');
        const request = store.put(value, value.key);

        request.onerror = function (e) {
            console.log('[addItemAndUpdateVuex] Error', e.target.error.name);
        };
    } else {
        return null
    }
}

function setLang(db, lang) {
    if (isSupported) {
        const transaction = db.transaction(['lang'], 'readwrite');
        const store = transaction.objectStore('lang');
        const request = store.put(lang, 'lang');

        request.onsuccess = function () {
            // Success - the data is updated!
        };
        request.onerror = function (e) {
            console.log('[setLang], Error', e.target.error.name);
        };
    } else {
        return null
    }
}

export const GET_FCM_TOKEN = async () => {
    if (isSupported) {
        try {
            if (typeof messaging !== 'undefined') {
                return messaging.getToken();
            } else {
                return '';
            }
        } catch (e) {
            throw new Error(`[GET_FCM_TOKEN]${e}`);
        }
    } else {
        return null
    }
}

export const CHANGE_LANG = (lang) => {
    if (isSupported) {
        let db;
        const openRequest = indexedDB.open('NOTIFICATIONS', version);
        const onSuccess = (openEvent={}, msg='') => {
            db = openEvent.target.result;
            if (db.objectStoreNames.contains('lang')) {
                const objectStore = db.transaction(['lang'], 'readwrite').objectStore('lang');
                const request = objectStore.get('lang');

                request.onsuccess = function () {
                    const requestUpdate = objectStore.put(lang, 'lang');

                    requestUpdate.onerror = function (error) {
                        console.log(`${msg} [CHANGE_LANG]`, error);
                    };
                    requestUpdate.onsuccess = function () {
                        // Success - the data is updated!
                    };
                };
                request.onerror = function (error) {
                    console.log(` ${msg} [CHANGE_LANG] Error!`, error.target.error.name);
                };
            } else {
                db.createObjectStore('lang');
                const transaction = openEvent.target.transaction;
                transaction.oncomplete = function () {
                    setLang(db, localStorage.getItem('lang') || 'en');
                }
            }
        }

        openRequest.onupgradeneeded = function (openEvent) {
            onSuccess(openEvent, 'onupgradeneeded');
        }
        openRequest.onsuccess = function (openEvent) {
            onSuccess(openEvent, 'onsuccess');
        }
        openRequest.onerror = function (error) {
            console.log('[CHANGE_LANG] ', error.target.error.name);
        }
    } else {
        return null
    }
}

export const GET_ALL_NOTI_ITEMS_FROM_DB = () => {
    if (isSupported) {
        let db;
        const openRequest = indexedDB.open('NOTIFICATIONS', version);
        return new Promise((resolve, reject) => {
            openRequest.onsuccess = async function (openEvent) {
                db = openEvent.target.result;
                db.transaction(['items']).objectStore('items').getAll().onsuccess = function (successEvent) {
                    resolve(successEvent.target.result);
                };
            };
            openRequest.onerror = function (error) {
                console.log('[GET_ALL_NOTI_ITEMS_FROM_DB]', error.target.error.name);
                reject([]);
            };
        })
    } else {
        return []
    }
}

export const REMOVE_NOTI_ITEM_FROM_DB = (key) => {
    if (isSupported) {
        let db;
        const openRequest = indexedDB.open('NOTIFICATIONS', version);
        return new Promise((resolve, reject) => {
            openRequest.onsuccess = async function (e) {
                db = e.target.result;
                if (db.objectStoreNames.contains('items')) {
                    db.transaction(['items'], "readwrite").objectStore('items').delete(key).onsuccess = function () {
                        resolve(true);
                    };
                }
            };
            openRequest.onerror = function (e) {
                console.log('[REMOVE_NOTI_ITEM_FROM_DB]', e.target.error.name);
                reject(false);
            };
        })
    } else {
        return null
    }
}

export const REMOVE_ALL_NOTI_ITEMS_FROM_DB = () => {
    if (isSupported) {
        let db;
        const openRequest = indexedDB.open('NOTIFICATIONS', version);
        return new Promise((resolve, reject) => {
            openRequest.onsuccess = async function (e) {
                db = e.target.result;
                if(db.objectStoreNames.contains('items')) {
                    db.transaction(['items'], "readwrite").objectStore('items').clear();
                }
                resolve();
            };
            openRequest.onerror = function (e) {
                console.log('[REMOVE_ALL_NOTI_ITEMS_FROM_DB] error', e.target.error.name);
                reject(false);
            };
        })
    } else {
        return null
    }
}

/**
 * db의 모든 아이템 객체의 read값을 true로 변경한다.
 * @param unreadNotifications
 * @returns {Promise<unknown>}
 * @constructor
 */
export const CHANGE_NOTI_STATUS_TO_READ = (unreadNotifications) => {
    if (isSupported) {
        let db;
        const openRequest = indexedDB.open('NOTIFICATIONS', version);
        return new Promise((resolve, reject) => {
            openRequest.onsuccess = async function (openEvent) {
                db = openEvent.target.result;
                if (db.objectStoreNames.contains('items')) {
                    const objectStore = db.transaction(['items'], 'readwrite').objectStore('items');

                    unreadNotifications.forEach(element => {
                        const request = objectStore.get(element.key);

                        request.onsuccess = function (successEvent) {
                            let data = successEvent.target.result;
                            data.read = true;
                            const requestUpdate = objectStore.put(data, element.key);

                            requestUpdate.onerror = function (error) {
                                console.log('[CHANGE_NOTI_STATUS_TO_READ] ', error);
                            };
                            requestUpdate.onsuccess = function () {
                                // Success - the data is updated!
                            };
                        };
                        request.onerror = function (error) {
                            console.log('[CHANGE_NOTI_STATUS_TO_READ] Error! ', error.target.error.name);
                        };
                    })
                }
                resolve();
            };
            openRequest.onerror = function (error) {
                console.log('[CHANGE_NOTI_STATUS_TO_READ]', error.target.error.name);
                reject();
            };
        })
    } else {
        return null
    }
}

/**
 * db를 조회해 read가 false인 값이 있는지 찾는다.
 * 안읽은 메세지가 있을 경우(read가 false인 값이 있는 경우) false를 반환
 * 안읽은 메세지가 없거나, firebase를 사용할 수 없는 경우,  ture를 반환
 * @returns {Promise<unknown>|boolean}
 * @constructor
 */
export const CHECK_FOR_UNREAD_NOTI = () => {
    if (isSupported) {
        let db;
        const openRequest = indexedDB.open('NOTIFICATIONS', version);
        return new Promise((resolve, reject) => {
            openRequest.onsuccess = async function (event) {
                db = event.target.result;
                if (db.objectStoreNames.contains('items')) {
                    db.transaction(['items']).objectStore('items').getAll().onsuccess = function (e) {
                        const result = e.target.result;
                        result.forEach(element => {
                            if (!element.read) {
                                resolve(false);
                            }
                        })
                        resolve(true);
                    };
                }

            };
            openRequest.onerror = function (e) {
                console.log('[CHECK_FOR_UNREAD_NOTI]', e.target.error.name);
                reject();
            };
        })
    } else {
        return true
    }
}

export const deleteFirebaseDB = () => {
    try {
        indexedDB.deleteDatabase('NOTIFICATIONS');
        indexedDB.deleteDatabase('firebase-installations-database');
        indexedDB.deleteDatabase('firebase-messaging-database');
    } catch (e) {

    }
}